"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  title: 'New to Shootsta HUB?',
  links: [{
    label: 'What is Shootsta?',
    linkText: 'Shootsta services, guidelines and limitations',
    link: ''
  }, {
    label: 'The Shootsta HUB',
    linkText: 'Upload, brief, submit, review and manage your video projects',
    link: ''
  }, {
    label: 'Get Started',
    linkText: 'Check out our Getting Started guide',
    link: ''
  }]
}, {
  title: 'Useful Links',
  links: [{
    label: 'What is a Shootsta Video?',
    linkText: 'Learn step by step how to shoot the perfect video',
    link: ''
  }, {
    label: 'The Shootsta Kits',
    linkText: 'Meet our video gear and how to use it',
    link: ''
  }, {
    label: 'Creative Support',
    linkText: 'Get help and advice from professional Video Producers',
    link: ''
  }]
}];
exports.default = _default;